import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e0e7bb68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "LogicalReasoningRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请根据题目选择答案：", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_image = _resolveComponent("el-image");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter question-img-list"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse($props.data.question.questionField), qimg => {
      return _openBlock(), _createBlock(_component_el_image, {
        key: qimg,
        src: qimg,
        style: {
          "max-width": "70%"
        }
      }, null, 8, ["src"]);
    }), 128))]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32 question-img-list"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse($props.data.question.optionField), qimg => {
      return _openBlock(), _createBlock(_component_el_image, {
        key: qimg,
        src: qimg,
        style: {
          "max-width": "70%"
        }
      }, null, 8, ["src"]);
    }), 128))]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_AnswerButtonGroup, {
      onChoose: $options.onChoosed,
      review: $props.review,
      reviewMode: $props.reviewMode,
      options: $props.data.question.questionOption.split(',')
    }, null, 8, ["onChoose", "review", "reviewMode", "options"])]),
    _: 1
  }), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex flex-col bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}